// Texty promo pruhu nad hlavičkou (promoBar.js).
import { NBSP } from '../../modules/money.js';

export default {
  shipStrong: 'DOPRAVA ZDARMA',
  shipLead: ' na výdejní místo',
  shipTail: ' při nákupu',
  shipCta: 'Doplnit zásoby',
  saleStrong: 'SLEVOAKCE',
  saleLead: ' právě běží',
  saleTail: ' – zlevněné zboží napříč sortimentem',
  saleCta: 'Zobrazit slevy',
  /** „DORUČÍME V SOBOTU" / „DORUČÍME V PONDĚLÍ" podle klíče závozu */
  fastDay: { sat: 'V SOBOTU', sun: 'V PONDĚLÍ' },
  fastStrong: 'DORUČÍME ',
  fastOrder: ' – objednejte ',
  fastSunday: ' – v neděli svážíme, objednejte ',
  /** „ s GLS" za datem (mezera před dopravcem je NBSP z modulu) */
  fastWith: 's',
  close: 'Zavřít oznámení',
  /** konec věty dopravy zdarma: „ nad 2 000 Kč." / „ při větším nákupu." */
  over: (price) => ' nad ' + price + '.',
  bigger: ' při větším nákupu.',
  /** akce na dopravu (#322): „PPL ZA 19 Kč" · „ na výdejní místo do 10 kg" ·
   *  (jen desktop) „ – nad 2 000 Kč zdarma, akce platí do 25. 10." */
  promoStrong: (carrier, price) => carrier + ' ZA ' + price,
  promoLead: (maxKg) => ' na výdejní místo do ' + maxKg + NBSP + 'kg',
  // tečku za datem dává konec věty (`text`), jinak by desktop četl „25. 10.."
  promoTail: (freeFrom, until) => ' – nad ' + freeFrom + ' zdarma, akce platí do ' + until.replace(/\.$/, ''),
};
